var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('peek-form',{attrs:{"title":_vm.$t('mango.mango'),"subtitle":_vm.subtitle,"footer":false}},[_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":require('assets/mango.png')}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }